import { getCurrencyValue } from 'ChannelSummary/utils'
import classNames from 'classnames'
import PropTypes from 'prop-types'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { storeNameColumn } from 'TableCommon/defaultColumns'

import Box from '@mui/material/Box'

const TitleIcons = storeNameColumn.RowRenderer

function TableWeatherRow({ data, index, style }) {
  const { t: translate } = useTranslation()
  const { showModal, maxRevenue, stores } = data
  const store = stores[index]
  const modalHandler = () => showModal(store)
  const barWidth = Math.round((100 * store.revenueCurrent) / maxRevenue)

  return (
    <Box
      style={style}
      onClick={modalHandler}
      className={classNames('row cursor-pointer', { 'is-temporary-closed': store.temporaryClosed })}
    >
      <div className="row-wrapper flex-row">
        <div className="cell-bar" style={{ width: `${barWidth}%` }} />

        <div className="cell-title flex-row">
          <TitleIcons {...data} store={store} />
        </div>

        <div className="cell-category tablet-portrait-up-only">
          <span className={classNames('category', `is-${store.cluster === '-' ? 'none' : store.cluster.toLocaleLowerCase()}`)}>
            {store.cluster}
          </span>
        </div>

        <div className="cell cell-value">
          <span>{getCurrencyValue(store.revenueCurrent, store.currency, translate)}</span>
        </div>

        <div className="cell cell-weather">
          {typeof store.temperatureCurrent === 'number' ? (
            <>
              <div className="cell-weather-temperature cell-weather-temperature_current">{store.temperatureCurrent}℃</div>
              <div className={`cell-weather-temperature-icon fm fm-${store.weatherIconCurrent}`} />
            </>
          ) : (
            '-'
          )}
          {typeof store.temperatureCompared === 'number' ? (
            <>
              <div className="cell-weather-separator">/</div>
              <div className="cell-weather-temperature cell-weather-temperature_compared">{store.temperatureCompared}℃</div>
              <div className={`cell-weather-temperature-icon fm fm-${store.weatherIconCompared}`} />
            </>
          ) : (
            '-'
          )}
        </div>
      </div>
    </Box>
  )
}

TableWeatherRow.propTypes = {
  data: PropTypes.shape({
    maxRevenue: PropTypes.number,
    showModal: PropTypes.func,
    stores: PropTypes.arrayOf(PropTypes.object),
  }),
  index: PropTypes.number,
  style: PropTypes.object,
}

export default TableWeatherRow
